export { durationStep, durations } from '../utils/durations';

export type { Durations } from '../utils/durations';
